<template>
    <site-img class="site-img" v-bind="siteImgOptions" :class="customClass">
        <div class="site-card" :style="layerStyle">
            <slot></slot>
            <slot name="title">
                <div class="title" v-if="title" v-html="title" style="font-family: var(--font-bold);"></div>
            </slot>
            <slot name="description">
                <div
                    class="description"
                    v-if="description"
                    v-html="description"
                ></div>
            </slot>
            <slot name="button">
                <a
                    class="button"
                    :style="buttonStyle"
                    :href="action.type === 'callback' ? null : formatHref(action.href)"
                    :target="action.target"
                    @click="click(action)"
                    rel="noopener noreferrer"
                    v-html="fmtButtonText"
                    style="font-family: var(--mg-button-font);"
                ></a>
            </slot>
        </div>
    </site-img>
</template>

<script>
export default {
    data: function() {
        return {};
    },
    props: {
        siteImgOptions: {
            type: Object,
            default: () => ({})
        },
        customClass: String,
        title: String,
        description: String,
        callback: Function,
        buttonStyle: Object,
        buttonText: String,
        href: String,
        target: String,
        layerStyle: Object,
        action: {
            type: Object,
            default: () => ({
                type: 'url',
                href: '/',
                target: '_blank',
                callback: () => {}
            })
        }
    },
    computed: {
        fmtButtonText() {
            // transform tag a to span
            if (this.buttonText) {
                const reg = /<a([^>]*)>(.*?)<\/a>/g
                return this.buttonText.replace(reg, '<span$1>$2</span>')
            }
            return this.buttonText
        }
    },
    methods: {
        click(action) {
            if (action.type === 'callback' && action.callback) {
                action.callback();
            }
        },
        formatHref(href) {
            //  if href is a domain name ， But the link is not of the form http://www.xx.com|https://www.xx.xom|//www.xx.com
            if (
                /\./.test(href) &&
                !/^(http:\/\/|https:\/\/|\/\/)/.test(href)
            ) {
                return '//' + href;
            }
            return href;
        }
    }
};
</script>

<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';
.site-card {
    a.button {
        display: block;
    }
}
</style>
